import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MaterialSnackbar from '@mui/material/Snackbar';

import Alert from '@mui/material/Alert';
import { setSnackbarDisplay } from '../../../../slices/feedbackSlice';

const AUTOHIDE_DURATION = 4000;

// ⛔ Une ERREUR ne s'efface pas toute seule. Quatre secondes suffisent pour
// « Ouvrage supprimé », pas pour « Cet ouvrage est prêté et n'a pas encore été
// rendu. Marquez son retour avant de le supprimer, ou archivez-le… » : 180
// caractères et deux instructions, dont la bibliothécaire a besoin PENDANT
// qu'elle agit. Le message partait avant d'avoir servi, et il n'y a aucun
// moyen de le rappeler.
//
// 📌 WCAG 2.1 niveau AA, critère 2.2.1 « délai ajustable ». Le public de ce
// produit est souvent bénévole et lit sans se presser. `null` laisse la main :
// la croix de fermeture reste, et c'est elle qui décide.
const duree = (severite) => (severite === 'error' ? null : AUTOHIDE_DURATION);

export default function Snackbar() {
  const dispatch = useDispatch();

  const { snackbarDisplayed, snackbarContent } = useSelector(
    (state) => state.feedback,
  );

  // ⛔ Un clic ailleurs ne referme pas une ERREUR. MUI appelle `onClose` avec
  // `reason === 'clickaway'` au premier clic n'importe où : rendre l'erreur
  // persistante et la laisser partir au geste suivant serait la même perte,
  // une seconde plus tard. La croix et la touche Échap restent, elles sont
  // délibérées. Les messages de succès, eux, se referment comme avant.
  const handleClose = (evenement, raison) => {
    if (raison === 'clickaway' && snackbarContent.severity === 'error') {
      return;
    }
    dispatch(setSnackbarDisplay(false));
  };

  return (
    <MaterialSnackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      open={snackbarDisplayed}
      autoHideDuration={duree(snackbarContent.severity)}
      onClose={handleClose}
    >

      <Alert
        onClose={handleClose}
        severity={snackbarContent.severity}
        // ⚠️ MUI étiquette sa croix « Close », en anglais. Elle est devenue la
        // sortie délibérée d'une erreur qui ne s'efface plus toute seule : la
        // seule commande que la bibliothécaire DOIT trouver ne peut pas être
        // dans une autre langue que le reste de l'écran.
        closeText="Fermer"
      >
        {snackbarContent.message}
      </Alert>
    </MaterialSnackbar>
  );
}
